import { hsmBackendClient } from './client';
import { IControllerResponse, Subscription } from './types';

export interface PostSubscriptionInput {
  renewalDate?: string;
}

/**
 * Activates (creates) the initial HSM subscription for a company that has none
 * yet — the billing container required before contracting plans, packages or
 * credit. Hits `POST /company/{companyId}/subscription` and returns the created
 * `Subscription`. `renewalDate` is optional; omitted, the backend uses its
 * default (day 15 of the month).
 *
 * @param companyId Target company id.
 * @param input     Optional renewal date for the new subscription.
 */
export async function postSubscription(
  companyId: string,
  input: PostSubscriptionInput = {}
): Promise<Subscription> {
  const response = await hsmBackendClient.post<
    IControllerResponse<Subscription>
  >(`/company/${encodeURIComponent(companyId)}/subscription`, input);

  if (!response.data.result) {
    throw new Error(
      response.data.message ?? 'Respuesta del backend sin result'
    );
  }
  return response.data.result;
}
